(function (Drupal) {
  Drupal.behaviors.cardColumnReorder = {
    attach: function (context, settings) {
      if (window.innerWidth > 992) {
        const paragraphs = document.querySelectorAll('.paragraph--type--card-column-6-6', context);
        
        paragraphs.forEach(paragraph => {
          const positionField = paragraph.querySelector('.field--name-field-position .field__item');
          
          if (positionField && positionField.textContent.trim() === 'Derecha') {
            const columns = paragraph.querySelectorAll('.row .col-md-6');
            
            if (columns.length === 2) {
              const row = columns[0].parentNode;
              row.insertBefore(columns[1], columns[0]);
            }
          }
        });
      }
    }
  };
})(Drupal);
